import rLang from "../languages.js"
const inits = {
  rLang,
  lang: 0
}

const LangReducer = (s = inits, action) => {
  const {payload} = action
  switch (action.type) {
    case '_LANG':
      return { ...s, [payload[0]]: payload[1] }

    default:
      return s;
  }
};
export default LangReducer
